/**
 * Helpers for determining UI and theme.
 */
export {shouldUseDspUi, shouldUseDwmUi} from './planUiMode';
export type {PlanUiAuth} from './planUiMode';

/**
 * DSP mobile menu is in-flow unless `hasFixedMobileMenu`; skip redundant shell `pt-12` on these surfaces only.
 */
export function isMobileInFlowFinancialSurfacePath(pathname: string): boolean {
  if (pathname === '/card-shield' || pathname.startsWith('/card-shield/')) {
    return true;
  }
  if (pathname === '/transactions' || pathname.startsWith('/transactions/')) {
    return true;
  }
  if (pathname.startsWith('/txm-transactions/')) {
    return true;
  }
  if (pathname === '/marketplace' || pathname.startsWith('/marketplace/')) {
    return true;
  }
  return false;
}
